/* ─────────────────────────────────────────────
   Guide articles — behaviour for the rs-guide-* sections.
   Loaded (defer) by sections/rs-guide-intro.liquid,
   sections/rs-guide-how.liquid and sections/rs-guide-feature.liquid.
   Guarded, so a second load is a no-op.

   1. Share: [data-rs-guide-share] shares the PAGE LINK only (Sam
      2026-09-30). Web Share API first; otherwise copies the link and
      writes the button's data-success text into its status node.
   2. Free swatch: on a guide page, a click on any link carrying
      swatch=1 opens the shared #rs-swatch-modal in place, with
      contact[Source] from the link's src param (same allowlist as
      assets/rs-swatch-deeplink.js). Without JS, or if the modal is
      missing, the link navigates and the deeplink script opens the
      modal after the reload. Reads #rs-swatch-modal and
      contact[Source]; owns neither (snippets/rs-swatch-request.liquid).
   3. Photo-card arrows (≤989 scroll row): scroll the track one card,
      disable at the ends, hide when every card fits.
   4. Feature leader lines (≥990, rs-guide-feature): one forest line per
      callout, from its dot on the photo to the left of its label,
      measured so it meets the label's middle at any width. Route
      "across": along, turn [data-elbow]px after the photo, down, along.
      Route "down": down from the dot, then along. A first leg passing
      close to another dot steps away from it (at most the dot's radius,
      hidden under the dot). Redrawn on resize.
      Without JS the dots show and the lines do not.
───────────────────────────────────────────── */
(function () {
  if (window.rsGuideLoaded) return;
  window.rsGuideLoaded = true;

  var SRC_OK = /^[a-z0-9_-]{1,32}$/;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function share(btn) {
    var url = btn.getAttribute('data-url') || window.location.href;
    var title = btn.getAttribute('data-title') || document.title;
    var status = btn.parentNode && btn.parentNode.querySelector('[data-rs-guide-share-status]');

    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
      return;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () {
        if (status) status.textContent = btn.getAttribute('data-success') || '';
      }).catch(function () {});
    }
  }

  function openSwatch(link) {
    var modal = document.getElementById('rs-swatch-modal');
    if (!modal || !window.rsModal || typeof window.rsModal.open !== 'function') return false;

    var url;
    try { url = new URL(link.href, window.location.href); } catch (e) { return false; }
    if (url.searchParams.get('swatch') !== '1') return false;

    var src = url.searchParams.get('src');
    var field = modal.querySelector('[name="contact[Source]"]');
    if (field) field.value = src && SRC_OK.test(src) ? src : 'guide';
    return window.rsModal.open('rs-swatch-modal') !== false;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var btn = e.target.closest('[data-rs-guide-share]');
    if (btn) {
      e.preventDefault();
      share(btn);
      return;
    }

    var link = e.target.closest('a[href*="swatch=1"]');
    if (link && openSwatch(link)) e.preventDefault();
  });

  function initTrack(root) {
    var track = root.querySelector('[data-rs-guide-track]');
    var arrows = root.querySelector('[data-rs-guide-arrows]');
    if (!track || !arrows) return;
    var prev = arrows.querySelector('[data-dir="prev"]');
    var next = arrows.querySelector('[data-dir="next"]');

    function step() {
      var card = track.querySelector('li');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var scrolls = max > 1 && getComputedStyle(track).overflowX !== 'visible';
      arrows.hidden = !scrolls;
      if (!scrolls) return;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
    }

    function go(dir) {
      track.scrollBy({ left: dir * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  var SVG_NS = 'http://www.w3.org/2000/svg';
  var desktop = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;

  function drawLines(fig) {
    var svg = fig.querySelector('[data-rs-guide-feat-lines]');
    var media = fig.querySelector('[data-rs-guide-feat-media]');
    if (!svg || !media) return;
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    if (!desktop || !desktop.matches) return;

    var f = fig.getBoundingClientRect();
    var m = media.getBoundingClientRect();
    // The svg sits in the media box; lines are drawn in figure space and
    // shifted by the media box's offset.
    var ox = m.left - f.left;
    var oy = m.top - f.top;
    svg.setAttribute('width', Math.round(f.width));
    svg.setAttribute('height', Math.round(f.height));
    svg.style.left = -ox + 'px';
    svg.style.top = -oy + 'px';

    // Every dot, so a line can keep clear of the others' rings.
    var items = Array.prototype.slice.call(fig.querySelectorAll('.rs-guide-feat__item[data-x]'));
    var dots = items.map(function (li) {
      return {
        x: ox + m.width * parseFloat(li.getAttribute('data-x')) / 100,
        y: oy + m.height * parseFloat(li.getAttribute('data-y')) / 100
      };
    });
    var CLEAR = 18; // ring radius 9.5 + ~8px air
    var DOT_R = 4.5; // a step this small hides under the line's own dot

    items.forEach(function (li, i) {
      var text = li.querySelector('.rs-guide-feat__text') || li;
      var t = text.getBoundingClientRect();
      var ax = dots[i].x;
      var ay = dots[i].y;
      var lx = t.left - f.left - 16;
      var ly = t.top - f.top + t.height / 2;
      var d;
      if (li.getAttribute('data-route') === 'down') {
        d = 'M' + ax + ',' + ay + 'V' + ly + 'H' + lx;
      } else {
        var straight = Math.abs(ly - ay) < 6; // keep near-level lines straight
        var ex = straight ? lx : ox + m.width + (parseFloat(li.getAttribute('data-elbow')) || 0);
        // The first leg runs along at the dot's height. If it passes too
        // close to another dot, step it away by up to DOT_R (the step is
        // hidden under this line's own dot).
        var hy = ay;
        dots.forEach(function (o, j) {
          if (j === i || o.x <= ax || o.x >= ex) return;
          var dy = hy - o.y;
          if (Math.abs(dy) >= CLEAR) return;
          var want = (dy <= 0 ? o.y - CLEAR : o.y + CLEAR) - ay;
          hy = ay + Math.max(-DOT_R, Math.min(DOT_R, want));
        });
        var start = 'M' + ax + ',' + ay + (hy !== ay ? 'V' + hy : '');
        d = straight ? start + 'H' + lx : start + 'H' + ex + 'V' + ly + 'H' + lx;
      }
      var path = document.createElementNS(SVG_NS, 'path');
      path.setAttribute('d', d);
      svg.appendChild(path);
    });
  }

  function initFeature(fig) {
    var redraw = function () { drawLines(fig); };
    if (window.ResizeObserver) {
      new ResizeObserver(redraw).observe(fig);
    } else {
      window.addEventListener('resize', redraw);
    }
    if (desktop && desktop.addEventListener) desktop.addEventListener('change', redraw);
    var img = fig.querySelector('[data-rs-guide-feat-media] img');
    if (img && !img.complete) img.addEventListener('load', redraw);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(redraw);
    redraw();
  }

  function init() {
    document.querySelectorAll('[data-rs-guide-cards]').forEach(initTrack);
    document.querySelectorAll('[data-rs-guide-feat]').forEach(initFeature);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
